module.exports = __webpack_public_path__ + "static/media/Supabase1.11ff0416.png";